import { motion } from "framer-motion";
const colors = [
  "#001625",
  "#023851",
  "#035A7C",
  "#057CA8",
  "#069ED3",
  "#1AAADE",
  "#2FB6E9",
  "#43C1F3",
  "#57CDFE",
  "#43C1F3",
  "#2FB6E9",
  "#1AAADE",
  "#069ED3",
  "#047199",
  "#02435F",
  "#001625",
];
const globeColors = [
  "#010C1D",
  "#010F1E",
  "#011120",
  "#011421",
  "#011622",
  "#08263B",
  "#0F3654",
  "#16646C",
  "#1D5685",
  "#16646C",
  "#0F3654",
  "#08263B",
  "#011622",
  "#011320",
  "#010F1F",
  "#010C1D",
];
export default function GlobeLoaderIcon({
  height,
  width,
}: {
  width?: string;
  height?: string;
}) {
  return (
    <svg
      className="z-50"
      fill="#000000"
      width={width ? width : 240}
      height={height ? height : 240}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 430.605 430.605"
    >
      <g>
        <motion.path
          animate={{ fill: globeColors }}
          transition={{ repeat: Infinity, duration: 5, ease: "easeInOut" }}
          d="M189.939,85.443c-73.326,0-132.981,59.655-132.981,132.982c0,73.326,59.655,132.981,132.981,132.981
		s132.981-59.655,132.981-132.981c0-2.726-0.093-5.43-0.255-8.115h27.273v-5h-27.665C315.666,138.117,258.84,85.443,189.939,85.443z
		 M293.575,168.641c-3.552-2.59-7.405-5.06-11.554-7.395c-7.39-4.159-15.502-7.746-24.151-10.751
		c-3.005-8.649-6.593-16.762-10.752-24.152c-2.334-4.148-4.804-8.002-7.394-11.553C263.193,126.109,282.256,145.171,293.575,168.641
		z M302.093,205.309h-33.755c-0.644-11.371-2.14-22.429-4.402-32.974C282.701,180.811,296.453,192.349,302.093,205.309z
		 M226.477,225.192l14.883-14.883h9.191c0.104,2.685,0.161,5.39,0.161,8.115c0,19.176-2.638,37.433-7.245,53.526
		c-16.093,4.608-34.351,7.245-53.526,7.245s-37.434-2.638-53.526-7.245c-4.607-16.093-7.245-34.35-7.245-53.526
		s2.638-37.433,7.245-53.526c16.093-4.607,34.35-7.245,53.526-7.245s37.434,2.638,53.526,7.245
		c3.544,12.378,5.919,26.038,6.827,40.411h-11.004l-16.348,16.348L226.477,225.192z M189.939,103.443
		c18.203,0,34.842,16.083,46.09,40.985c-14.563-3.124-30.113-4.775-46.09-4.775c-15.977,0-31.527,1.651-46.09,4.775
		C155.098,119.526,171.736,103.443,189.939,103.443z M140.154,114.789c-2.59,3.551-5.06,7.405-7.394,11.553
		c-4.159,7.39-7.747,15.503-10.752,24.152c-8.649,3.005-16.762,6.592-24.151,10.751c-4.148,2.334-8.002,4.804-11.554,7.395
		C97.623,145.171,116.686,126.109,140.154,114.789z M115.943,172.336c-3.125,14.561-4.775,30.113-4.775,46.089
		c0,15.976,1.65,31.527,4.774,46.089c-24.902-11.248-40.984-27.887-40.984-46.089C74.958,200.223,91.04,183.584,115.943,172.336z
		 M86.305,268.209c3.551,2.59,7.404,5.06,11.553,7.394c7.39,4.159,15.502,7.746,24.152,10.751
		c3.005,8.65,6.592,16.762,10.751,24.152c2.334,4.148,4.804,8.002,7.394,11.553C116.686,310.74,97.624,291.678,86.305,268.209z
		 M189.939,333.406c-18.203,0-34.842-16.082-46.09-40.985c14.563,3.124,30.113,4.775,46.09,4.775c15.977,0,31.527-1.651,46.09-4.775
		C224.781,317.324,208.143,333.406,189.939,333.406z M239.725,322.06c2.59-3.551,5.06-7.405,7.394-11.553
		c4.159-7.39,7.746-15.502,10.751-24.152c8.65-3.005,16.763-6.592,24.152-10.751c4.148-2.334,8.002-4.804,11.553-7.394
		C282.255,291.678,263.193,310.74,239.725,322.06z M263.936,264.514c3.124-14.562,4.774-30.113,4.774-46.089
		c0-2.72-0.064-5.422-0.158-8.115h35.288c0.706,2.661,1.08,5.37,1.08,8.115C304.921,236.627,288.839,253.266,263.936,264.514z"
        />
        <motion.rect
          x="289.605"
          y="56.728"
          width="78"
          height="28"
          animate={{ fill: colors }}
          transition={{ repeat: Infinity, duration: 5, ease: "easeInOut" }}
        />
        <motion.rect
          x="352.605"
          y="193.809"
          width="78"
          height="28"
          animate={{ fill: colors }}
          transition={{ repeat: Infinity, duration: 4.5, ease: "easeInOut" }}
        />
        <motion.polygon
          points="263.274,73.229 285.514,73.229 285.514,68.229 260.753,68.229 244.15,90.684 248.17,93.656 	"
          animate={{ fill: colors }}
          transition={{ repeat: Infinity, duration: 4.5, ease: "easeInOut" }}
        />
        <motion.rect
          x="0"
          y="345.877"
          width="78"
          height="28"
          animate={{ fill: colors }}
          transition={{ repeat: Infinity, duration: 2.5, ease: "easeInOut" }}
        />
        <motion.polygon
          points="103.054,357.377 80.814,357.377 80.814,362.377 105.575,362.377 122.178,339.922 118.158,336.949 	"
          animate={{ fill: colors }}
          transition={{ repeat: Infinity, duration: 2.5, ease: "easeInOut" }}
        />
      </g>
    </svg>
  );
}
